import { render, staticRenderFns } from "./ReferenciasComponent.vue?vue&type=template&id=36dc1eaf&scoped=true"
import script from "./ReferenciasComponent.vue?vue&type=script&lang=js"
export * from "./ReferenciasComponent.vue?vue&type=script&lang=js"
import style0 from "./ReferenciasComponent.vue?vue&type=style&index=0&id=36dc1eaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc1eaf",
  null
  
)

export default component.exports